






























import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class ServiceScheduleDate extends Vue {
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
}
